type IconWrapperProps = React.ComponentProps<'span'>

export const IconWrapper = ({ children, ...props }: IconWrapperProps) => {
  return <span {...props}>{children}</span>
}
